import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-contacto',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contacto.html',
  styleUrls: ['./contacto.css']
})
export class ContactoComponent {
  
  contactoForm: FormGroup;
  isLoading: boolean = false;
  dropdownOpen: boolean = false;
  
  ciudadSeleccionadaLabel: string = 'Seleccionar';

  ciudades = [
    { value: 'lima', label: 'Lima' },
    { value: 'arequipa', label: 'Arequipa' },
    { value: 'cusco', label: 'Cusco' },
    { value: 'trujillo', label: 'Trujillo' },
    { value: 'piura', label: 'Piura' },
    { value: 'chiclayo', label: 'Chiclayo' },
    { value: 'iquitos', label: 'Iquitos' },
    { value: 'huancayo', label: 'Huancayo' },
    { value: 'otro', label: 'Otro' }
  ];

  constructor(
    private fb: FormBuilder, 
    private http: HttpClient,
    private modalService: ModalService
  ) {
    this.contactoForm = this.fb.group({
      nombre: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      telefono: ['', [Validators.required]],
      empresa: [''],
      ciudad: ['', [Validators.required]],
      detalle: ['', [Validators.required]]
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  seleccionarCiudad(ciudad: any) {
    this.contactoForm.patchValue({ ciudad: ciudad.value });
    this.ciudadSeleccionadaLabel = ciudad.label;
    this.dropdownOpen = false;
  }

  onSubmit() {
    if (this.contactoForm.invalid) {
      this.contactoForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const url = 'https://corporacionrehobot.com/php/api/enviar_contacto.php';
    const formData = this.contactoForm.value;

    this.http.post<any>(url, formData).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: (response) => {
        if (response.status === 'success') {
          this.modalService.open({ title: '¡Éxito!', message: 'Mensaje enviado correctamente. Gracias por contactarnos.' });
          this.contactoForm.reset();
          this.ciudadSeleccionadaLabel = 'Seleccionar';
        } else {
          this.modalService.open({ title: 'Error', message: 'Hubo un error al guardar el mensaje en la BD: ' + response.message, isError: true });
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error('Error en la solicitud:', err);
        this.modalService.open({ title: 'Error de Conexión', message: 'Ocurrió un error al enviar el formulario. Por favor, intente de nuevo más tarde.', isError: true });
      }
    });
  }
}